import axios from "axios";
import React, { useState, useEffect, useContext } from "react";
import { StateContext } from "../../App";

function Withdrawal() {

  const { state, dispatch } = useContext(StateContext);

  const [users, setUsers] = useState([]);

  const getWithdrawalRequest = () => {

    dispatch({ type: "SET_LOADING", payload: true });
  
    axios
      .get("/admin/request")
      .then((result) => {
        // console.log(result.data);
        setUsers(result.data);
        
        dispatch({ type: "SET_LOADING", payload: false });
      })
      .catch((error) => {
        console.log("ERR! Fetching Customer Request ==>", error);
        dispatch({ type: "SET_LOADING", payload: false });
      });

  }

  // Component Mounts Here!
  useEffect(() => {

    getWithdrawalRequest();
   
  }, []);

  const deleteRequest = (id, email) => {
    
    // console.log("Delet Request should be made now!", id, '&', email ? email : null)
    dispatch({ type: "SET_LOADING", payload: true });

    const email_address = email ? email : null;

    axios
      .delete(`/admin/request/${id}/${email_address}`)
      .then((result) => {
        // console.log(result.data);
        dispatch({ type: "SET_LOADING", payload: false });

        result.data.success && alert("Withdrawal request deleted!");
        result.data.errMsg && alert(result.data.errMsg);
        result.data && getWithdrawalRequest();
      })
      .catch((error) => {
        console.log("ERR! Deleting Request ==>", error);
        dispatch({ type: "SET_LOADING", payload: false });
      });
  };


  const approveWithdrawalRequest = (id, amount, email, walletAddress) => {
    window.event.preventDefault();

    console.log("ID used to delete Request ==>", id)

    dispatch({ type: "SET_LOADING", payload: true })


    let options = { amount, email, walletAddress };

    axios.post("/admin/request/approval", options)
      .then(result => {
        console.log(result);
        console.log(result.data);
        result.data && dispatch({ type: "SET_LOADING", payload: false });
      
      if (result.data ) {
        
        setTimeout(() => {
        
          deleteRequest(id);  /* The ID is of the Request API and not the Customers APi */
        }, 500)

      }
        
    })
      .catch(error => {
        dispatch({ type: "SET_LOADING", payload: false });
        
        console.log("ERR! Aproving Withdraw Request ==>", error);
    })



  }


  const withdrawalDetails =
    users &&
    users.map((user) => {
      return (
        <div key={user._id} className="col s12 m12 l12">
          <div className="card horizontal indigo darken-2">
            <div className="card-content">
              <div className="details">
                <form
                  onSubmit={() => approveWithdrawalRequest(
                    user._id,
                    user.amount,
                    user.email,
                    user.wallet_address
                  )}
                  className="approveWithdrawalRequest">
                  <button className="approve-btn green">
                    Approve request
                  </button>
                  <ul>
                    <li><input type="text" name="email" defaultValue={ user.email }/> </li>
                    <li><input type="text" name="amount" defaultValue={ user.amount } /> </li>
                    <li><input type="text" name="walletAddress" defaultValue={ user.wallet_address } /> </li>
                    <li><input type="text" defaultValue={ user.crypto_type } /> </li>
                  </ul>
                </form>
              </div>
              <div className="delete-button">
                <button onClick={() => deleteRequest(user._id, user.email)}>
                  {" "}
                  delete request
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    });

  return (
    <div className="withdrawal">
      <div className="header-withdraw indigo darken-2">
        <button data-target="slide-out" className="sidenav-trigger Button-menu hide-on-large-only">
          <i className="fas fa-bars"></i>
        </button>
        <h1>Withdrawal request</h1>
        <p>Total Request - { users && users.length }</p>
      </div>
      <br />

      <div className="container">
        <div className="row">
          {users.length !== 0 ? (
            withdrawalDetails
          ) : (
            <div className="col s12 m12 l12">
              <div className="card horizontal indigo darken-4">
                <div className="card-content">
                  <p>No withdrawal request!</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Withdrawal;
